import { Trans, useLingui } from '@lingui/react/macro'
import { visitHooks } from '$src/lib/trpcHooks'
import { propertyHooks } from '$src/lib/trpcHooks/propertyHooks'
import { UserEmailBadge } from '$src/components/company-portal/UserEmailBadge'
import { PastVisit } from '$src/modules/visit/PastVisit'
import { FutureVisit } from '$src/modules/visit/FutureVisit'
import { Center, Loader, Text } from '@mantine/core'
import { AppPage } from '@markku/components'
import { createFileRoute } from '@tanstack/react-router'

function CompanyVisitDetail() {
  const { t } = useLingui()
  const { companyId, visitId } = Route.useParams()

  const { data: visit, isLoading: isLoadingVisit } = visitHooks.useGetById(
    Number(visitId),
  )
  const { data: property, isLoading: isLoadingProperty } =
    propertyHooks.useGetById(visit?.propertyId ?? 0, {
      enabled: !!visit?.propertyId,
    })

  const isLoading = isLoadingVisit || isLoadingProperty
  const backTarget = `/company-portal/${companyId}/visits`

  if (isLoading) {
    return (
      <AppPage
        title={t`Visit`}
        backTarget={backTarget}
        rightSection={<UserEmailBadge />}
      >
        <Center py="xl">
          <Loader size="md" />
        </Center>
      </AppPage>
    )
  }

  if (!visit || (property && property.customerId !== Number(companyId))) {
    return (
      <AppPage
        title={t`Visit not found`}
        backTarget={backTarget}
        rightSection={<UserEmailBadge />}
      >
        <Center py="xl">
          <Text c="dimmed">
            <Trans>Visit not found</Trans>
          </Text>
        </Center>
      </AppPage>
    )
  }

  const isPastVisit = new Date(visit.startTime) < new Date()

  return (
    <AppPage
      title={isPastVisit ? t`Past visit` : t`Upcoming visit`}
      backTarget={backTarget}
      rightSection={<UserEmailBadge />}
    >
      {isPastVisit ? (
        <PastVisit visit={visit} property={property} />
      ) : (
        <FutureVisit visit={visit} />
      )}
    </AppPage>
  )
}

export const Route = createFileRoute(
  '/_app/company-portal/$companyId/visits/$visitId',
)({
  component: CompanyVisitDetail,
})
